export default __webpack_public_path__ + "static/frame-mothers-day-f4ce275f460ad71b46a60163a14405e7.mp4";